<script>
import simplebar from "simplebar-vue";
import i18n from "../i18n";
import { ADMIN_MICOAPP_API } from "@/config/social-api";
import {
  summarizeMicoappLogData,
  parseMicoappLogTimeMs,
} from "@/utils/micoapp-logs";

export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/zh.jpg"),
          language: "zh",
          title: "中文",
        },
        {
          flag: require("@/assets/images/flags/en.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/ja.jpg"),
          language: "ja",
          title: "日本語",
        },
        {
          flag: require("@/assets/images/flags/es.jpg"),
          language: "es",
          title: "Español",
        },
      ],
      logodark: require("@/assets/images/mainlogo_darkgree_web.png"),
      logowhite: require("@/assets/images/mainlogo_white_web.png"),
      current_language: "zh",
      userinfo: [],
      noticelist: [],
      micoappLogs: [],
      micoappLogsLoading: false,
    };
  },
  components: { simplebar },
  computed: {
    hasNotificationBadge() {
      return (
        (this.micoappLogs && this.micoappLogs.length > 0) ||
        (this.noticelist && this.noticelist.length > 0)
      );
    },
  },
  mounted() {
    var that = this;
    try {
      const raw = localStorage.getItem("user");
      that.userinfo = raw ? JSON.parse(raw) : {};
    } catch (e) {
      that.userinfo = {};
    }
    if (localStorage.getItem("notice")) {
      try {
        that.noticelist = JSON.parse(localStorage.getItem("notice"));
      } catch (e) {
        that.noticelist = [];
      }
    }
    that.fetchMicoappLogs();
    var languagecode = navigator.language;
    languagecode = languagecode.substr(0, 2);
    that.current_language = languagecode;
    i18n.locale = languagecode;
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },
    getjurisdiction() {
      var that = this;
      that.$axios
        .post(that.apiuri, {
          action: "jurisdiction",
        })
        .then(function (response) {
          that.$root.jurisdiction = response.data.map;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    lang(value, data) {
      return this.$t(value, data);
    },
    readmessage(idx) {
      // this.$t("global.notice.online")
      console.log(idx);
    },
    fetchMicoappLogs() {
      const openid = this.userinfo && this.userinfo.openid;
      if (!openid) return;
      this.micoappLogsLoading = true;
      this.$axios
        .post(
          ADMIN_MICOAPP_API,
          { action: "get_micoapp_logs", limit: 7 },
          { headers: { Openid: openid } }
        )
        .then((res) => {
          const body = res && res.data ? res.data : {};
          const list = body.data;
          this.micoappLogs = Array.isArray(list) ? list : [];
        })
        .catch((e) => {
          console.error(e);
          this.micoappLogs = [];
        })
        .finally(() => {
          this.micoappLogsLoading = false;
        });
    },
    logSummary(row) {
      return summarizeMicoappLogData(row && row.data);
    },
    logTimeMs(row) {
      return parseMicoappLogTimeMs(row && row.time);
    },
    openMicoappFromLog(appid) {
      if (!appid || !this.$router) return;
      const path = `/micoapp/${encodeURIComponent(appid)}`;
      if (this.$route.path === path) return;
      this.$router.push({ path }).catch((err) => {
        if (err && err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
  },
  filters: {
    formatTimer: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    timeago: function (value, lang) {
      let now = Date.parse(new Date());
      let ago = now - value;
      let age = ago / 1000;
      if (age < 60) {
        return lang("global.time.sec", { time: age });
      }
      if (age >= 60 && age < 3600) {
        return lang("global.time.min", { time: Math.floor(age / 60) });
      }
      if (age >= 3600) {
        return lang("global.time.hor", { time: Math.floor(age / 3600) });
      }
      if (age >= 43200) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt height="32" />
            </span>
            <span class="logo-lg">
              <img :src="logodark" alt height="50" />
            </span>
          </a>

          <a href="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt height="32" />
            </span>
            <span class="logo-lg">
              <img :src="logowhite" alt height="50" />
            </span>
          </a>
        </div>

        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item waves-effect"
          id="vertical-menu-btn"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class
              :src="
                require('@/assets/images/flags/' + current_language + '.jpg')
              "
              alt="Header Language"
              height="16"
            />
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language)"
            :link-class="{ active: entry.language === current_language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            @click="initFullScreen"
          >
            <i class="ri-fullscreen-line"></i>
          </button>
        </div>

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
          @shown="fetchMicoappLogs"
        >
          <template v-slot:button-content>
            <i class="ri-notification-3-line"></i>
            <span class="noti-dot" v-if="hasNotificationBadge"></span>
          </template>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a
                  href="javascript:void(0)"
                  class="small"
                  :class="{ 'text-muted': micoappLogsLoading }"
                  @click.prevent="fetchMicoappLogs"
                >
                  <span
                    v-if="micoappLogsLoading"
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  刷新
                </a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 280px">
            <div
              v-if="
                !micoappLogsLoading &&
                !micoappLogs.length &&
                !noticelist.length
              "
              class="px-3 pb-3 text-muted text-center small"
            >
              暂无通知
            </div>
            <a
              href="javascript:void(0)"
              class="text-reset notification-item"
              v-for="row in micoappLogs"
              :key="'micoapp-log-' + row.id"
              @click.prevent="openMicoappFromLog(row.appid)"
            >
              <div class="media">
                <div class="avatar-xs mr-3 flex-shrink-0">
                  <span
                    class="avatar-title bg-soft-primary text-primary rounded-circle font-size-16"
                  >
                    <i class="ri-apps-2-line"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1 font-size-13">
                    小程序
                    <span class="text-muted font-weight-normal">{{
                      row.appid || "—"
                    }}</span>
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1 micoapp-log-summary-text">
                      {{ logSummary(row) }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      <template v-if="logTimeMs(row)">
                        {{ logTimeMs(row) | timeago(lang) }}
                      </template>
                      <template v-else>{{ row.time || "—" }}</template>
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="javascript:;"
              class="text-reset notification-item"
              v-for="(val, idx) in noticelist"
              :key="'dev-' + idx"
              @click="readmessage(idx)"
            >
              <div class="media">
                <div class="media-body" v-if="val.type2 === 'device'">
                  <h6 class="mt-0 mb-1">
                    {{
                      $t("global.notice.devicev2", {
                        status: $t("global.notice." + val.type1),
                      })
                    }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("global.notice.device", { device: val.edid }) }}
                      {{ $t("global.notice." + val.type1) }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ val.time | timeago(lang) }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top">
            <router-link
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/notifications"
            >
              <i class="mdi mdi-arrow-right-circle mr-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </router-link>
          </div>
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              :src="
                'https://admin.aicoiot.beer/headimg/' +
                userinfo.username +
                '.svg'
              "
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1">{{
              userinfo.username
            }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <!-- <a class="dropdown-item" href="#">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.profile') }}
          </a>
          <a class="dropdown-item" href="#">
            <i class="ri-wallet-2-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.mywallet') }}
          </a>
          <a class="dropdown-item d-block" href="#">
            <span class="badge badge-success float-right mt-1">11</span>
            <i class="ri-settings-2-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.settings') }}
          </a>
          <a class="dropdown-item" href="#">
            <i class="ri-lock-unlock-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.lockscreen') }}
          </a>
          <div class="dropdown-divider"></div> -->
          <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t("navbar.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.notify-item {
  .active {
    color: #16181b;
    background-color: #f8f9fa;
  }
}

.micoapp-log-summary-text {
  white-space: pre-line;
  line-height: 1.55;
  word-break: break-word;
}
</style>